import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {PessoaComponent} from "./pages/crud/pessoa/edit/pessoa.component";
import {ListPessoaComponent} from "./pages/crud/pessoa/list/list-pessoa.component";
import {DashboardComponent} from "./pages/dashboard/dashboard.component";
import {ListLocalComponent} from "./pages/crud/local/list-local/list-local.component";
import {EditLocalComponent} from "./pages/crud/local/edit-local/edit-local.component";
import {FolderPage} from "./folder/folder.page";
import {ListProjetoComponent} from "./pages/crud/projeto/list-projeto/list-projeto.component";
import {EditProjetoComponent} from "./pages/crud/projeto/edit-projeto/edit-projeto.component";
import {EditEspecimeComponent} from "./pages/crud/especime/edit/edit-especime.component";
import {JornadaComponent} from "./pages/crud/jornada/edit/jornada.component";
import {ListMonitoramentoComponent} from "./pages/crud/monitoramento/list/list-monitoramento.component";
import {EditMonitoramentoComponent} from "./pages/crud/monitoramento/edit/edit-monitoramento.component";
import {TrackingComponent} from "./pages/tracking/tracking.component";
import {ListEspecimeComponent} from "./pages/crud/especime/list-especime/list-especime.component";
import {SincronizacaoComponent} from "./pages/sincronizacao/sincronizacao.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {path: 'dashboard', component: JornadaComponent},
  {path: 'sincronizacao', component: SincronizacaoComponent},

  {path: 'registro/especime', component: ListEspecimeComponent},
  {path: 'registro/especime/edit/:id', component: EditEspecimeComponent},
  // {path: 'registro/especime/edit/:id/:observacao', component: EditEspecimeComponent },
  {path: 'registro/especime/new', component: EditEspecimeComponent},

  {path: 'tracking/:id', component: TrackingComponent},

  {path: 'registro/monitoramento', component: ListMonitoramentoComponent},
  {path: 'registro/monitoramento/edit/:id', component: EditMonitoramentoComponent},
  {path: 'registro/monitoramento/new', component: EditMonitoramentoComponent},

  {path: 'registro/jornada', component: JornadaComponent},


  {path: 'cadastro/projeto', component: ListProjetoComponent},
  {path: 'cadastro/projeto/edit/:id', component: EditProjetoComponent},
  {path: 'cadastro/projeto/new', component: EditProjetoComponent},

  {path: 'cadastro/pessoa', component: ListPessoaComponent},
  {path: 'cadastro/pessoa/edit/:id', component: PessoaComponent},
  {path: 'cadastro/pessoa/new', component: PessoaComponent},

  {path: 'cadastro/local', component: ListLocalComponent},
  {path: 'cadastro/local/edit/:id', component: EditLocalComponent},
  {path: 'cadastro/local/new', component: EditLocalComponent},
  {path: 'cadastro/local/new/:pai', component: EditLocalComponent},
  {path: 'folder/:id', component: FolderPage}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
